import { PageShell } from "@/components/site/PageShell";
import { InvestorHero } from "@/components/investor/InvestorHero";
import { InvestorAfaCalculator } from "@/components/investor/InvestorAfaCalculator";
import { RentalService } from "@/components/investor/RentalService";
import { Apartments } from "@/components/landing/Apartments";
import { ApartmentsCompare } from "@/components/landing/ApartmentsCompare";
import { Funding } from "@/components/landing/Funding";
import { MortgageCalculator } from "@/components/landing/MortgageCalculator";
import { RentalYieldForecast } from "@/components/landing/RentalYieldForecast";
import { ProjectBulkPurchase } from "@/components/landing/ProjectBulkPurchase";
import { Contact } from "@/components/landing/Contact";
import { Reveal } from "@/hooks/useReveal";
import { SeoHead } from "@/components/SeoHead";
import { resolveSeo } from "@/data/apartmentSeo";
import { useLang } from "@/i18n/LanguageProvider";

const SITE = "https://neubau-kaufen-wiesbaden.de";

const INVESTOR_SEO = {
    canonical: `${SITE}/investor`,
    ogImage:
        "https://customer-assets.emergentagent.com/job_gaugasse21-wiesbaden/artifacts/b57oc53l_1000004280.jpg",
    de: {
        title:
            "Kapitalanlage Wiesbaden-Biebrich · 5 % AfA · KfW-förderfähig · G21 Neubau",
        description:
            "Neubau-Wohnungen als Kapitalanlage: 5 % degressive AfA für Neubau, KfW-Förderung, Effizienzhaus 40, Vollservice für Vermietung & Verwaltung. Direktverkauf vom Bauträger in Wiesbaden-Biebrich.",
        ogTitle: "G21 Wiesbaden · Kapitalanlage mit 5 % AfA & Vollservice",
        ogDescription:
            "4 Eigentumswohnungen direkt vom Bauträger. Steuerlich attraktiv durch degressive AfA, KfW-förderfähig, eigene Wärmepumpe. Auf Wunsch übernehmen wir Vermietung & Verwaltung.",
        twitterTitle: "G21 Wiesbaden · Kapitalanlage · 5 % AfA",
        twitterDescription:
            "4 Wohnungen Effizienzhaus 40 · 5 % AfA · KfW · Vollservice für Anleger.",
    },
    en: {
        title:
            "Investment property Wiesbaden-Biebrich · 5 % AfA · KfW-eligible · G21 new build",
        description:
            "New-build apartments as a capital investment: 5 % declining-balance AfA, KfW funding, energy class 40, full leasing & management service. Direct from the developer in Wiesbaden-Biebrich.",
        ogTitle: "G21 Wiesbaden · investment with 5 % AfA & full service",
        ogDescription:
            "4 condominiums direct from the developer. Tax-efficient via declining-balance AfA, KfW-eligible, own heat pump. We optionally handle leasing & management.",
        twitterTitle: "G21 Wiesbaden · investment · 5 % AfA",
        twitterDescription:
            "4 apartments, energy class 40 · 5 % AfA · KfW · full investor service.",
    },
};

export default function InvestorPage() {
    const { lang } = useLang();

    return (
        <PageShell testId="investor-page">
            {(company) => (
                <>
                    <SeoHead seo={resolveSeo(INVESTOR_SEO, lang)} />
                    <InvestorHero />
                    <Reveal><RentalService /></Reveal>
                    <Reveal><InvestorAfaCalculator /></Reveal>
                    <Reveal><Apartments /></Reveal>
                    <Reveal><ApartmentsCompare /></Reveal>
                    <Reveal><MortgageCalculator /></Reveal>
                    <Reveal><RentalYieldForecast /></Reveal>
                    <Reveal><Funding /></Reveal>
                    <Reveal><ProjectBulkPurchase /></Reveal>
                    <Reveal><Contact company={company} /></Reveal>
                </>
            )}
        </PageShell>
    );
}
